// extracted by mini-css-extract-plugin
module.exports = {"topCardsContainer":"layout_topCardsContainer__3sv6x","bottomCardsContainer":"layout_bottomCardsContainer__3vdUs","activityContainer":"layout_activityContainer__23vWc"};